<template>
  <ResourceView :entityId="$route.params.machineId" entityClass="Machine" :defaultEmailTemplate="defaultEmailTemplate">
  </ResourceView>
</template>


<script>
import ResourceView from "@/views/admin/machines/ResourceView.vue";

export default {
  name: "ViewMachineResources",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    ResourceView,
  },

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    defaultEmailTemplate() {
      return {
        CustomerId: this.CustomerId,
        To: '',
        Subject: '',
        Body: "",
        CC: null,
        Attachments: null,
      };
    },

    CustomerId() {
      return this.Machine && this.Machine.CustomerId;
    },

    Machine: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },
  },

  watch: {},
};
</script>


<style scoped></style>